// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      height: 30px;
      width: 30px;
      display: inline-block;
      line-height: 0;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/core/svg-icons/clock-icon.component.ts"],"names":[],"mappings":";IACI;MACE,YAAY;MACZ,WAAW;MACX,qBAAqB;MACrB,cAAc;IAChB","sourcesContent":["\n    :host {\n      height: 30px;\n      width: 30px;\n      display: inline-block;\n      line-height: 0;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
